import { ALERT_TYPES } from "./Constants";
import { DUE_TODAY_CONGRATULATIONS_STORAGE_KEY } from "./dueTodayCongratulationsPreference";

const STORAGE_KEYS = {
  jobDeadline: "alertNotif_jobDeadline",
  scoopStatus: "alertNotif_scoopStatus",
};

/** Preference keys that must survive logout / 401 localStorage.clear(). */
const PERSISTED_PREFERENCE_KEYS = [
  STORAGE_KEYS.jobDeadline,
  STORAGE_KEYS.scoopStatus,
  DUE_TODAY_CONGRATULATIONS_STORAGE_KEY,
  "showFloatingBtn",
];

const readBool = (key, defaultValue = true) => {
  const stored = localStorage.getItem(key);
  if (stored === null) return defaultValue;
  return stored === "true";
};

export const isJobDeadlineAlertsEnabled = () =>
  readBool(STORAGE_KEYS.jobDeadline, true);

export const isScoopStatusAlertsEnabled = () =>
  readBool(STORAGE_KEYS.scoopStatus, true);

export const setJobDeadlineAlertsEnabled = (enabled) => {
  localStorage.setItem(STORAGE_KEYS.jobDeadline, String(enabled));
};

export const setScoopStatusAlertsEnabled = (enabled) => {
  localStorage.setItem(STORAGE_KEYS.scoopStatus, String(enabled));
};

export const isAnyAlertTypeEnabled = () =>
  isJobDeadlineAlertsEnabled() || isScoopStatusAlertsEnabled();

export const isBannerAlertType = (alert) => {
  if (!alert) return false;
  if (alert.alert_type === ALERT_TYPES.JOB_DEADLINE_MISSED) {
    return isJobDeadlineAlertsEnabled();
  }
  if (alert.alert_type === ALERT_TYPES.SCOOP_STATUS_CHANGED) {
    return isScoopStatusAlertsEnabled();
  }
  return false;
};

export const filterAlertsByPreferences = (alerts = []) =>
  (alerts || []).filter((alert) => {
    if (alert.alert_type === ALERT_TYPES.JOB_DEADLINE_MISSED) {
      return isJobDeadlineAlertsEnabled();
    }
    if (alert.alert_type === ALERT_TYPES.SCOOP_STATUS_CHANGED) {
      return isScoopStatusAlertsEnabled();
    }
    return true;
  });

export const isUnseenAlert = (alert) =>
  Number(alert?.is_read) === 0 && Number(alert?.is_dismissed) === 0;

/** Snapshot notification prefs before localStorage.clear(). */
export const snapshotNotificationPreferences = () => {
  const snapshot = {};
  PERSISTED_PREFERENCE_KEYS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      snapshot[key] = value;
    }
  });
  return snapshot;
};

/** Restore notification prefs after localStorage.clear(). */
export const restoreNotificationPreferences = (snapshot) => {
  if (!snapshot || typeof snapshot !== "object") return;
  Object.entries(snapshot).forEach(([key, value]) => {
    if (value != null) {
      localStorage.setItem(key, value);
    }
  });
};

/** Clear localStorage while keeping notification preferences. */
export const clearLocalStoragePreservingNotificationPreferences = () => {
  const snapshot = snapshotNotificationPreferences();
  localStorage.clear();
  restoreNotificationPreferences(snapshot);
};

export { STORAGE_KEYS as ALERT_NOTIFICATION_STORAGE_KEYS };
